import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import ModalActionCreator from 'action_creators/modal';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import { t } from 'services/translation';
import $ from 'jquery';
import Form from '../form';
import './index.scss';

const ModalContent = createReactClass({
  displayName: 'TourPage-ContactGuide-ModalContent',

  mixins: [StoreInterestMixin],

  propTypes: {
    guideId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    tourId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    guidePictureUrl: PropTypes.string,
    isCompany: PropTypes.bool,
    tourName: PropTypes.string,
  },

  getInitialState() {
    return {
      messageSent: false,
    };
  },

  getDefaultProperties() {
    return {
      guidePictureUrl: null,
      isCompany: false,
    };
  },

  getStoreInterests() {
    return {
      messageSent: 'contact.sendingCompleted',
    };
  },

  _isCompany() {
    return this.props.isCompany === true;
  },

  _contactAside() {
    return (
      <div className="TourPage-ContactGuide-aside">
        <h3 className="ContactModal-header plugins">{t('INQUIRE_ABOUT')}</h3>
        <div className="ContactModal-guide-name">{this.props.tourName}</div>
        <hr className="ContactModal-hr plugins" />
        <p>
          {t(
            'FEEL_FREE_TO_CONTACT_US_WITH_ANY_QUESTIONS_AND_WE_WILL_GET_BACK_TO_YOU_SHORTLY'
          )}
          .
        </p>
      </div>
    );
  },

  _contactForm() {
    return (
      <Form
        tourId={this.props.tourId}
        guideId={this.props.guideId}
        isCompany={this.props.isCompany}
      />
    );
  },

  _renderContactSend() {
    return (
      <div className="TourPage-ContactGuide-ModalContent">
        {this._contactForm()}
        {this._contactAside()}
      </div>
    );
  },

  _closeModal(e) {
    e.preventDefault();
    $('body').removeClass('modal-open');
    ModalActionCreator.hide();
  },

  _renderSendSuccess() {
    return (
      <div className="TourPage-ContactGuide-ModalContent-success">
        <div>{`${t('THANK_YOU_FOR_YOUR_INTEREST')}!`}</div>
        <div>{`${t('WE_WILL_GET_BACK_TO_YOU_SHORTLY')}.`}</div>
        <button
          className="ui button large TourPage-ContactGuide-submit-button brand-bg"
          onClick={this._closeModal}
        >
          {t('OKAY')}
        </button>
      </div>
    );
  },

  render() {
    return this.state.messageSent
      ? this._renderSendSuccess()
      : this._renderContactSend();
  },
});

export default ModalContent;
